import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import { textStyles } from '@marketing-sites/ui'
import type { ComposeComponentImageFragment } from '../../../.graphql/generated-types'
import { useContentful } from '../../utils/contentful-context'

export interface PlainComposeComponentImageProps {
  data: ComposeComponentImageFragment
  width: number
  height: number
}
export function PlainComposeComponentImage({
  data,
  width,
  height,
}: PlainComposeComponentImageProps) {
  const { blockComponents } = useContentful()
  const { ContentfulRichText, ContentfulImageWithPlaceholder } = blockComponents

  if (data.imageAsset?.url) {
    const { url } = data.imageAsset

    const placeholderWidth = Math.ceil(width / 100)
    const placeholderHeight = Math.ceil(height / 100)
    const placeholderUrl = new URL(url)
    placeholderUrl.search = `?w=${placeholderWidth.toString()}&h=${placeholderHeight.toString()}&fit=fill`
    return (
      <div className="my-12 flex w-full flex-col items-center justify-center">
        <div className="relative block">
          <ContentfulImageWithPlaceholder
            alt={data.altText ?? ''}
            src={url}
            height={height}
            width={width}
            className="rounded border"
            blurDataURL={placeholderUrl.href}
            placeholder="blur"
          />
        </div>
        {data.caption?.json && (
          <div>
            <ContentfulRichText
              document={data.caption.json as Document}
              entries={data.caption.links.entries}
              className={textStyles.figcaption}
            />
          </div>
        )}
      </div>
    )
  }
  return <div></div>
}
